<template>
  <div
    :class="[
      'anz-post-tooltip anz-post-tooltip--close-absolute anz-position-relative anz-bg-orange-light anz-b-rounded anz-flex anz-align-items-start',
      padding,
    ]"
  >
    <div class="anz-flex-sm anz-align-items-center anz-flex-fill">
      <div class="anz-mr-s-sm anz-align-center anz-align-left-sm">
        <h6 class="anz-fs-xs">
          <slot name="title" />
        </h6>
        <slot name="text" />
      </div>
      <slot name="action" />
    </div>

    <a-button
      class-name="anz-post-tooltip__closer anz-link anz-color-beige anz-ml-m anz-block"
      :style="{ marginTop: '-4px' }"
      @click="$emit('tooltip-close')"
      show-icon
      icon-width="0.7142em"
      icon-height="0.7142em"
      icon-name="cross-solid"
      icon-class="anz-block anz-mtn-xxs"
    />
  </div>
</template>

<script>
import AButton from '@/components/Forms/AButton'

export default {
  name: 'ATooltip',
  emits: ['tooltip-close'],
  components: { AButton },
  props: {
    padding: {
      type: String,
      default: 'anz-py-l',
    },
  },
}
</script>
